import { push } from 'redux-first-history';
import runSequentially from 'shared/app/utils/run-sequentially';
import { routeParamsSelector } from 'shared/app/state/selectors/routes';

import {
  SIGNAL_SIGN_IN,
  SIGNAL_SIGN_IN_ERROR,
  SIGNAL_SIGN_IN_SUCCESS,
  RESET_FORGOT_PASSWORD,
  RESET_FORGOT_PASSWORD_ERROR,
  RESET_FORGOT_PASSWORD_SUCCESS,
} from '../actions';
import getReturnUrlFromWindow from 'shared/app/utils/get-return-url-from-window';

// Sign In
export const signalSignIn = () => ({ type: SIGNAL_SIGN_IN });
export const signalSignInError = (error) => ({
  type: SIGNAL_SIGN_IN_ERROR,
  error,
});
export const signalSignInSuccess = () => ({ type: SIGNAL_SIGN_IN_SUCCESS });

export const signInWithSsoToken = ({ reputation }) => {
  return (dispatch, getState, { apiFetch }) => {
    const state = getState();
    const ssoToken = routeParamsSelector(state)?.token;
    const returnUrl = getReturnUrlFromWindow();

    return apiFetch(
      `/apiproxy/v1/account/signin/sso/${ssoToken}?returnUrl=${encodeURIComponent(
        returnUrl
      )}`,
      {
        method: 'post',
        body: {
          reputation,
        },
      }
    );
  };
};

// reset forgotten password
export const resetForgottenPassword = (resetPasswordPayload) => {
  return (dispatch, getState, { apiFetch }) => {
    dispatch({ type: RESET_FORGOT_PASSWORD });
    return apiFetch(`/apiproxy/v1/account/reset-password`, {
      method: 'post',
      body: resetPasswordPayload,
    })
      .then(() => {
        runSequentially(
          () => dispatch({ type: RESET_FORGOT_PASSWORD_SUCCESS }),
          () => dispatch(push('/account/reset-password-success'))
        );
      })
      .catch((error) => {
        dispatch({ type: RESET_FORGOT_PASSWORD_ERROR, error });
        throw error;
      });
  };
};
